module.exports = "/pages/business/foodslabo/charm_image_4.jpg";